<template>
  <div>
    <hr>
    <va-card v-if="iframeSessionStatsData">
      <div class="row justify--space-between mb-3">
        <h3>{{$t('leads.details.iframe_session_stats')}}</h3>
        <i class="clickable" :class="{ 'fa fa-chevron-up': isExpanded, 'fa fa-chevron-down ': !isExpanded}" style="font-size: 1.3em; font-weight: bold; color: #29C4AA" @click="() => isExpanded = !isExpanded"></i>
      </div>

      <div v-if="isExpanded">
        <va-card class="w-100">
          <h3>{{ this.$t('iframe.statistics.sessions.totals_per_page') }}</h3>
          <div class="row totalsGraph">
            <apexchart height="380" width="600" type="bar" :options="pagesVisitsStatsChartOptions" :series="pagesVisitsStatsSeries"></apexchart>
          </div>
        </va-card>

        <va-card class="w-100">
          <h3>{{ this.$t('iframe.statistics.sessions.mean_secs_per_page') }}</h3>
          <div class="row totalsGraph">
            <apexchart height="380" width="600" type="bar" :options="pagesAvgTimeStatsChartOptions" :series="pagesAvgTimeStatsSeries"></apexchart>
          </div>
        </va-card>
      </div>
    </va-card>
  </div>


</template>

<script>
import { IframeService } from '@/api/IframeService';

export default {
  props: {
    iframeSessionId: {
      type: Number,
      required: true
    }
  },
  async mounted() {
    this.iframeSessionStatsData = await IframeService.getSessionStatistics(this.iframeSessionId)
  },
  data () {
    return {
      isExpanded: false,
      iframeSessionStatsData: null,
      pagesVisitsStatsChartOptions: {
        responsive: [{
          breakpoint: undefined,
          options: {},
        }],
        chart: {
          type: 'bar'
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        colors: ['#015a60'],
        dataLabels: {
          enabled: true
        },
      },
      pagesAvgTimeStatsChartOptions: {
        responsive: [{
          breakpoint: undefined,
          options: {},
        }],
        chart: {
          type: 'bar'
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        colors: ['#6cb412'],
        dataLabels: {
          enabled: true
        },
      }
    }
  },
  computed: {
    pagesVisitsStatsSeries: function() {
      let data = [
        {
          name: '',
          data: []
        }
      ]
      this.iframeSessionStatsData.pageStats.forEach(elem => {
        //Pages visits stats
        data[0].data.push({
          x: elem.pageType === 'questionnaire_page' ? this.$t(`iframe.page_types.${elem.pageType}`) + ` (Perg. ${+(elem.pageOrder.toFixed(1).split('.')[1])})` : this.$t(`iframe.page_types.${elem.pageType}`),
          y: elem.totalVisited,
        })
      })
      return data
    },
    pagesAvgTimeStatsSeries: function() {
      let data = [
        {
          name: '',
          data: []
        }
      ]
      this.iframeSessionStatsData.pageStats.forEach(elem => {
        //Pages visits stats
        data[0].data.push({
          x: elem.pageType === 'questionnaire_page' ? this.$t(`iframe.page_types.${elem.pageType}`) + ` (Perg. ${+(elem.pageOrder.toFixed(1).split('.')[1])})` : this.$t(`iframe.page_types.${elem.pageType}`),
          y: Math.round(elem.avgTimeSpentSeconds),
        })
      })
      return data
    },
  }

};
</script>

<style scoped lang="scss">

</style>
